import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=2ec9ffa9&"
import script from "./Scanner.vue?vue&type=script&lang=ts&"
export * from "./Scanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports